var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * React Query hook for converting a proposal request into an ordinary proposal
 */
import { toast } from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { translate } from '@utils/i18n';
import { convertProposalRequest } from '../services/ProposalServices';
import { namespace } from '../ProposalShow/constants';
/**
 * Hook for converting a proposal request into an ordinary proposal
 * @param proposalId - The proposal ID
 * @returns Object containing the convertProposalRequest mutation
 */
export default function useConvertProposalRequest(proposalId) {
    const queryClient = useQueryClient();
    const convertProposalRequestMutation = useMutation(() => convertProposalRequest(proposalId), {
        onSuccess: (data) => __awaiter(this, void 0, void 0, function* () {
            if (!data.success) {
                toast.error(data.error || translate('proposal_request.convert_failed', { namespace }));
                return;
            }
            toast.success(data.message || translate('proposal_request.convert_succeeded', { namespace }));
            yield queryClient.invalidateQueries(['proposal', proposalId]);
        }),
        onError: (error) => {
            console.error('Error converting proposal request:', error);
            toast.error(translate('proposal_request.convert_failed', { namespace }));
        }
    });
    return {
        convertProposalRequest: convertProposalRequestMutation
    };
}
